var mobile_voucher_module = $("[class^=mob_voucher_list]");
var desktop_voucher_module = $("[class^=desk_voucher_block_list]");

//-- OPEN AND SELECT CODE
mobile_voucher_module.on("click", ".block", function(e) {

  //== init
  e.preventDefault();
  var voucher_item_class = ".block-wrapper";

  //== get the VOUCHER item which contains everything
  var voucher_item = $(this).parents(voucher_item_class);

  //== if it's not open, pre-select the voucher code
  if (!voucher_item.hasClass("open")) {
    voucher_item.find(".code").focus().select();
  }

  //== close all other VOUCHER item
  $(voucher_item_class).not(voucher_item).removeClass("open");

  //== switch OPEN state on main block
  voucher_item.toggleClass("open");
});


//-- [DESKTOP] HIDE CODE SECTION IF NO CODES
desktop_voucher_module.each(function() {
  var _this = $(this);

  _this.find(".voucher_row").each(function() {
    var _block = $(this);

    var code_wrapper = _block.find(".cell > .cashback");
    var code_text = code_wrapper.find(".percent:first-child()");
    var code = code_wrapper.find(".percent:last-child()");

    if ($.trim(code.text()) === "") {
      code_wrapper.hide();
    }
  });
});

//-- [MOBILE] HIDE CODE SECTION IF NO CODES
mobile_voucher_module.each(function() {
  var _this = $(this);

  _this.find(".block-wrapper").each(function() {
    var _block = $(this);

    var code_wrapper = _block.find(".code-wrapper");
    var code_inner = code_wrapper.find(".code-inner");
    var code = code_inner.find(".code");

    if (code.val() === "") {
      code_inner.hide();
    }
  });
});

/**
 * VOUCHERS
 */
//On click in a given line
$(document.body).on("click", "[class^=mob_list_item_showcase-] .line_title", function() {
  //gets which one has been clicked
  var index = $(".line_title").index(this);

  $(".line_title").each(function () {
    var lt = $(".line_title");

      //hide open lines and shows the clicked line
      if (lt.index(this) != index) {
        //rotates arrow and hides content
        $(this).children('.line_text_arrow').removeClass('open');
        $(this).removeClass('open').parent().children('.line_content').removeClass('open');
      }
      else {
        //rotates arrow and shows content
        $(this).children('.line_text_arrow').toggleClass('open');
        $(this).toggleClass('open').parent().children('.line_content').toggleClass('open');
      }

    });
});



//-- expire date management
var expire_date_elements = $("[data-type=module]").find("[data-search-expire]");
expire_date_elements.each(function() {
  var _el = $(this);
  if (_el.text().indexOf("null") !== -1) {
    _el.remove();
  }
});
